var React = require('react');

function LoaderSnowbird (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .st0 {\n        fill: #63a70a;\n      }\n\n      .st1 {\n        fill: #009bd1;\n      }\n    ")),React.createElement("g",{"id":"Layer_2","key":1},React.createElement("g",null,[React.createElement("path",{"className":"st0","d":"M32.53.01l.04.05-15.26,16.51-.04.03h-.02V6.67c0-.8.23-2.09.91-3.27.38-.66.93-1.23,1.53-1.77,1.24-1.1,2.98-1.59,4.52-1.63h8.32Z","key":0}),React.createElement("path",{"className":"st1","d":"M0,.01v.05l15.24,16.53h.04V6.68c0-.8-.23-2.09-.91-3.27-.28-.49-.65-.94-1.07-1.36-.15-.14-.31-.27-.46-.41C11.6.54,9.86.05,8.32.01,8.32.01,0,.01,0,.01Z","key":1})]))]);
}

LoaderSnowbird.defaultProps = {"id":"Layer_1","version":"1.1","viewBox":"0 0 32.57 16.6"};

module.exports = LoaderSnowbird;

LoaderSnowbird.default = LoaderSnowbird;
